import React, { useState } from 'react'
import './styles.scss'
import ReactModal from 'react-modal'
import CreateTicket from '../ticketsData/CreateTicket'
import AssignTicketModal from './AssignTicketModal'
import { Dropdown, Empty, Menu, Tooltip } from 'antd'
import LoadingSpinner from '../../LoadingSpinner'
import AdminTicketHamburger from './AdminTicketHamburger'
import { v4 as uuidv4 } from 'uuid'

interface MenuItem {
  label: string
  key: string
  title: string
}

interface IPROPS {
  setSelectedStatus: any
  selectedStatus: any
  loading: any
  refetch: any
  ticketData: any
  ticketCount: number
  setSearchQuery: any
  searchQuery: any
  currentPage: any
  setCurrentPage: any
  showEnteries: number
  setPriority: any
  priority: any
}

const items: MenuItem[] = [
  {
    label: 'null',
    title: 'Select Status',
    key: '4'
  },
  {
    label: 'OPEN',
    title: 'Open',
    key: '1'
  },

  {
    label: 'RESOLVED',
    title: 'Resolved',
    key: '2'
  },

  {
    label: 'INPROGRESS',
    title: 'In-progress',
    key: '3'
  },
  {
    label: 'ASSIGN',
    title: 'Assigned',
    key: '6'
  },

  {
    label: 'UNASSIGN',
    title: 'Not Assigned',
    key: '7'
  }
]

const AdminTicket: React.FC<IPROPS> = ({
  setSelectedStatus,
  selectedStatus,
  loading,
  refetch,
  ticketData,
  ticketCount,
  setSearchQuery,
  searchQuery,
  currentPage,
  setCurrentPage,
  showEnteries,
  setPriority,
  priority
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [ticketAssignModalOpen, setTicketAssignModalOpen] = useState<boolean>(false)
  const [assignTicketData, setAssignTicketData] = useState<any>([])

  const openModal = () => {
    setIsModalOpen(true)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }

  const openTicketAssignModal = (el: any) => {
    setTicketAssignModalOpen(true)
    setAssignTicketData(el)
  }

  const closeTicketAssignModal = () => {
    setTicketAssignModalOpen(false)
  }

  const headMap = [
    'S.No',
    'Ticket No.',
    'Title',
    'Description',
    'BgAccountId',
    'Status',
    'Priority',
    'Category',
    'Resolution',
    'Assigned',
    'Action'
  ]

  const getStatusColor = (priorit: string) => {
    switch (priorit) {
      case 'Closed':
        return 'text-danger back-danger'
      case 'Pending':
        return 'text-warning'
      case 'Open':
        return 'text-success'
      case 'In-Progress':
        return 'text-info'
      default:
        return ''
    }
  }

  const customModalStyles = {
    content: {
      top: '35%',
      left: '40%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-15%, -30%)',
      border: '2px solid #dde',
      backGround: 'white',
      width: '700px'
    }
  }

  const getPriorityLabel = (priorityId: any) => {
    switch (priorityId) {
      case 1:
        return { label: 'High', className: 'high-priority' }
      case 2:
        return { label: 'Low', className: 'low-priority' }
      case 3:
        return { label: 'Medium', className: 'medium-priority' }
      default:
        return { label: '', className: '' }
    }
  }

  const getCategoryLabel = (categoryId: number) => {
    switch (categoryId) {
      case 1:
        return 'Support'
      case 2:
        return 'Development'
      case 3:
        return 'Service'
      default:
        return ''
    }
  }

  const getStatusLabel = (statusId: number) => {
    switch (statusId) {
      case 1:
        return 'Open'
      case 2:
        return 'Resolved'
      case 3:
        return 'In-Progress'
      case 6:
        return 'Assign'
      case 7:
        return 'Unassign'
      default:
        return ''
    }
  }

  const handleSearchInputChange = (value: any) => {
    let searchValue = value.trim()
    if (searchValue.length > 0) {
      setSearchQuery(searchValue)
    } else {
      setSearchQuery('')
    }
  }

  const handleDropdownChange = (selectedItem: any) => {
    if (selectedItem?.label === 'null') {
      setSelectedStatus(null)
    } else {
      setSelectedStatus(selectedItem?.label)
    }
  }

  const menu = (
    <Menu>
      {items && items.length > 0
        ? items.map((item: any) => (
            <Menu.Item
              key={item.key}
              onClick={() => handleDropdownChange(item)}
              disabled={item.label === selectedStatus}
            >
              {item?.title}
            </Menu.Item>
          ))
        : null}
    </Menu>
  )

  // Pagination
  const totaltickets: any = ticketCount
  const totalPages = Math.ceil(totaltickets / showEnteries)
  // const indexOfLastticket = currentPage * showEnteries
  const indexOfFirstticket = currentPage * showEnteries - showEnteries
  // const currentticket = ticketData.slice(indexOfFirstticket, indexOfLastticket)

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
  }

  const nextPage = () => {
    if (totalPages > 0) {
      setCurrentPage((prevPage: number) => prevPage + 1)
    }
  }

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage: number) => prevPage - 1)
    }
  }

  // Generate snake handle pagination numbers
  const generatePaginationNumbers = () => {
    const numbers = []
    const maxVisibleNumbers = 4 // Maximum visible pagination numbers

    if (totalPages <= maxVisibleNumbers) {
      // If total pages are less than or equal to max visible numbers, show all
      for (let i = 1; i <= totalPages; i++) {
        numbers.push(i)
      }
    } else {
      const middleIndex = Math.ceil(maxVisibleNumbers / 2) // Middle index of the pagination numbers
      let startPage = currentPage - middleIndex + 1
      let endPage = currentPage + middleIndex - 1

      if (startPage < 1) {
        // If start page is less than 1, adjust start and end page accordingly
        endPage = startPage + maxVisibleNumbers - 1
        startPage = 1
      } else if (endPage > totalPages) {
        // If end page is greater than total pages, adjust start and end page accordingly
        startPage = endPage - maxVisibleNumbers + 1
        endPage = totalPages
      }

      for (let i = startPage; i <= endPage; i++) {
        numbers.push(i)
      }
    }

    return numbers
  }

  const handlePriority = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value === 'null' ? null : event.target.value
    setPriority(value)
  }

  return (
    <div>
      <div className='px-4 py-2'>
        <AdminTicketHamburger />
      </div>
      <div
        style={{
          padding: '15px',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px'
        }}
      >
        <div className='d-flex'>
          <div style={{ width: '85%', textAlign: 'justify' }}>
            <input
              placeholder='Search Ticket no., Title, Description'
              style={{
                padding: '10px',
                border: '1px solid rgb(215, 209, 209)',
                width: '45%',
                minWidth: '100px',
                borderRadius: '10px'
              }}
              value={searchQuery}
              onChange={(e) => handleSearchInputChange(e.target.value)}
            />
          </div>
          <div className='d-flex align-items-center justify-content-between flex-grow-1 gap-3'>
            <span>
              <select
                className='form-control text-primary bg-light-primary'
                name='priority'
                id='priority'
                style={{
                  width: '140px',
                  height: '42px',
                  borderRadius: '5px',
                  border: '#f1faff'
                }}
                value={priority}
                onChange={handlePriority}
              >
                <option value='null' selected>
                  Select Priority
                </option>
                <option value='LOW'>Low</option>
                <option value='MEDIUM'>Medium</option>
                <option value='HIGH'>High</option>
              </select>
            </span>
            <span className='w-30'>
              <Dropdown overlay={menu} trigger={['click']}>
                <i
                  className='bi bi-filter btn btn-light-primary'
                  style={{
                    fontSize: '25px',
                    flex: '1',
                    textAlign: 'center',
                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                    borderRadius: '10px',
                    padding: '3px 10px'
                  }}
                ></i>
              </Dropdown>
            </span>
            <span
              className='p-3 cursor-pointer flex-grow-1 text-center btn btn-light-primary'
              onClick={openModal}
              style={{
                borderRadius: '7px',
                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                fontSize: '15px',
                whiteSpace: 'nowrap'
              }}
            >
              + Create Ticket
            </span>
          </div>
        </div>

        {/* Ticket Data */}
        {loading ? (
          <LoadingSpinner />
        ) : (
          <div className='card-body p-0'>
            {!!ticketData && ticketData?.length > 0 ? (
              <div className='table-responsive border border-muted rounded-2'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bolder fs-6 text-primary bg-light-primary'>
                      {headMap?.map((el: string, index: number) => (
                        <th className='ps-4 min-w-100px' key={uuidv4()} scope='col'>
                          {el}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {ticketData?.map((curEl: any, index: any) => (
                      <React.Fragment key={uuidv4()}>
                        <tr>
                          <td className='ps-4 cursor-pointer fw-bold'>
                            {indexOfFirstticket + index + 1}
                          </td>
                          <td className='ps-4 cursor-pointer fw-bold'>{curEl?.ticketNumber}</td>
                          <td className='ps-4 cursor-pointer fw-bold'>
                            <Tooltip title={curEl?.title}>{curEl?.title} </Tooltip>
                          </td>
                          <td
                            className='ps-4 cursor-pointer fw-bold'
                            data-toggle='tooltip'
                            title={curEl?.description}
                          >
                            {curEl?.description && curEl.description.length > 250
                              ? `${curEl.description.slice(0, 250)}...`
                              : curEl?.description}
                          </td>

                          <td className='ps-4 cursor-pointer fw-bold'>{curEl?.bgAccountId}</td>
                          <td className={getStatusColor(curEl?.status)}>
                            {getStatusLabel(curEl?.StatusId)}
                          </td>
                          <td
                            className={` ps-4 cursor-pointer fw-bold ${
                              getPriorityLabel(curEl?.PriorityId).className
                            }`}
                          >
                            {getPriorityLabel(curEl?.PriorityId).label}
                          </td>
                          <td className='ps-4 cursor-pointer fw-bold'>
                            {getCategoryLabel(curEl?.TypeId)}
                          </td>
                          <td className='ps-4 cursor-pointer fw-bold'>
                            {curEl?.resolution ? curEl?.resolution : 'N/A'}
                          </td>
                          <td className='ps-4 cursor-pointer fw-bold'>
                            {curEl?.supportEngineerName
                              ? curEl?.supportEngineerName
                              : 'Not Assigned'}
                          </td>

                          <td
                            className='ps-4 cursor-pointer text-primary fw-bold'
                            onClick={() => openTicketAssignModal(curEl)}
                          >
                            <i className='bi bi-pencil-fill me-1'>Assign</i>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <Empty />
            )}
          </div>
        )}
      </div>
      {/* Pagination */}
      {ticketData?.length > 0 && (
        <div className='row'>
          <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
          <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
            <div className='dataTables_paginate paging_simple_numbers' id='kt_table_users_paginate'>
              <ul className='pagination pb-3'>
                <li className={`paginate_button page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button
                    type='button'
                    aria-controls='kt_table_users'
                    data-dt-idx='0'
                    className='btn primary page-link'
                    onClick={prevPage}
                  >
                    <i className='previous'></i>
                  </button>
                </li>
                {generatePaginationNumbers().map((pageNumber) => (
                  <li
                    key={pageNumber}
                    className={`paginate_button page-item ${
                      currentPage === pageNumber ? 'active' : ''
                    }`}
                  >
                    <button
                      type='button'
                      aria-controls='kt_table_users'
                      data-dt-idx={pageNumber}
                      className='btn primary page-link'
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li
                  className={`paginate_button page-item ${
                    currentPage === totalPages ? 'disabled' : ''
                  }`}
                >
                  <button
                    type='button'
                    aria-controls='kt_table_users'
                    data-dt-idx='0'
                    className='btn primary page-link'
                    onClick={nextPage}
                  >
                    <i className='next'></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      <ReactModal isOpen={isModalOpen} onRequestClose={closeModal} style={customModalStyles}>
        <CreateTicket closeModal={closeModal} refetch={refetch} />
      </ReactModal>
      <ReactModal
        isOpen={ticketAssignModalOpen}
        onRequestClose={closeTicketAssignModal}
        style={customModalStyles}
      >
        <AssignTicketModal
          closeModal={closeTicketAssignModal}
          assignTicketData={assignTicketData}
          adminTicketData={refetch}
        />
      </ReactModal>
    </div>
  )
}

export default AdminTicket
